import * as Yup from 'yup';
const isAllDigitsSame = (num) => /^(\d)\1{9}$/.test(num); // e.g., 9999999999
const isFirstSixSame = (num) => /^(\d)\1{5}/.test(num);   // e.g., 999999xxxx
const today = new Date();
today.setHours(0, 0, 0, 0);


export const stepSchemas = {
    1: Yup.object().shape({
        mobileNo: Yup.string()
            .matches(/^[6-9]\d{9}$/, 'Enter a valid 10-digit mobile number')
            .required('Mobile number is required')
            .test('all-sameDigit', 'Enter valid mobile no', (value) => {
                return !isAllDigitsSame(value)
            })
            .test('same-6digit', 'First 6 digit should not be same', (value) => {
                return !isFirstSixSame(value)
            }),
        destination: Yup.array().min(1, 'Select at least one destination'),
    }),
    2: Yup.object().shape({
        startDate: Yup.string().required('Start date is required'),
        endDate: Yup.string()
            .required('End date is required')
            .test('is-after-start', 'End date must be after start date', function (value) {
                const { startDate } = this.parent;
                return new Date(value) >= new Date(startDate);
            }),
    }),
    3: Yup.object().shape({
        travellers: Yup.array().of(
            Yup.object().shape({
                age: Yup.number().required('Select Age'),
                relation: Yup.string().required('Select Relation'),
            })
        ),
    }),
};


export const validateEditForm = Yup.object().shape({
    destination: Yup.array()
        .min(1, 'Please select at least one destination')
        .required('Destination is required'),

    mobileNo: Yup.string()
        .matches(/^[6-9]\d{9}$/, 'Enter a valid 10-digit mobile number')
        .required('Mobile number is required')
        .test('all-sameDigit', 'Enter valid mobile no', (value) => {
            return !isAllDigitsSame(value)
        })
        .test('same-6digit', 'First 6 digit should not be same', (value) => {
            return !isFirstSixSame(value)
        }),

    selectedTripType: Yup.string()
        .required('Trip type is required'),

    numberOfDays: Yup.number()
        .nullable()
        .when('selectedTripType', {
            is: (v) => v === 'Single' || v === 'Student',
            then: (schema) =>
                schema
                    .typeError('Number of days must be a number')
                    .required('Number of days is required')
                    .min(1, 'Must be at least 1 day'),
            otherwise: (schema) => schema.nullable(), // ✅ this is important!
        }),

    startDate: Yup.date()
        .required('Start date is required')
        .typeError('Invalid start date')
        .min(today, 'Start date cannot be in the past'),

    endDate: Yup.date()
        .required('End date is required')
        .typeError('Invalid end date')
        .min(today, 'End date cannot be in the past')
        .when('startDate', (startDate, schema) => {
            const parsedStart = new Date(startDate);
            return !isNaN(parsedStart.getTime())
                ? schema.min(parsedStart, 'End date cannot be before start date')
                : schema;
        }),


    travellers: Yup.array()
        .of(
            Yup.object().shape({
                age: Yup.number()
                    .nullable()
                    .min(0, 'Invalid age')
                    .required('Age is required'),
                relation: Yup.string().required('Relation is required')
            })
        )
        .min(1, 'At least one traveller is required')
});


export const validateShareModal = (tab) => {
    switch (tab) {
        case 'email':
            return Yup.object().shape({
                email: Yup.string()
                    .trim()
                    .email('Please enter a valid email')
                    .required('Email is required'),
            });
        case 'sms':
            return Yup.object().shape({
                mobileNumber: Yup.string()
                    .matches(/^[6-9]\d{9}$/, 'Enter valid 10-digit mobile number')
                    .required('Mobile number is required')
                    .test('all-sameDigit', 'Enter valid mobile no', (value) => {
                        return !isAllDigitsSame(value)
                    })
                    .test('same-6digit', 'First 6 digit should not be same', (value) => {
                        return !isFirstSixSame(value)
                    }),
            });
        case 'whatsapp':
            return Yup.object().shape({
                whatsappNumber: Yup.string()
                    .matches(/^[6-9]\d{9}$/, 'Enter valid 10-digit WhatsApp number')
                    .required('WhatsApp number is required')
                    .test('all-sameDigit', 'Enter valid mobile no', (value) => {
                        return !isAllDigitsSame(value)
                    })
                    .test('same-6digit', 'First 6 digit should not be same', (value) => {
                        return !isFirstSixSame(value)
                    })                ,
            });
        default:
            return Yup.object(); // fallback
    }
};
